import { Collapse, theme } from 'antd'
import type { GraviToolCall } from '../types'

export type ToolCallCardProps = { toolCall: GraviToolCall }

export function ToolCallCard({ toolCall }: ToolCallCardProps) {
  const { token } = theme.useToken()
  return (
    <Collapse
      ghost
      size='small'
      items={[
        {
          key: 'tool',
          label: `Used tool: ${toolCall.name}`,
          children: (
            <>
              <pre style={{ fontSize: 11, margin: 0 }}>
                {JSON.stringify(toolCall.input, null, 2)}
              </pre>
              {toolCall.result_preview && (
                <pre
                  style={{
                    fontSize: 11,
                    marginTop: 6,
                    color: token.colorTextSecondary,
                  }}
                >
                  {toolCall.result_preview}
                </pre>
              )}
            </>
          ),
        },
      ]}
    />
  )
}
